import Price from "../../../../appData/price"
import useExistingUserPromo from "../../../../hooks/useExistingUserPromo"
import useStrings from "../../../../localization/useStrings"
import native from "../../../../native/native"
import styles from "./Payment.module.scss"

const Payment = () => {
  const allStrings = useStrings()
  const strings = allStrings.premiumToUltimateBlackFriday

  const state = useExistingUserPromo()
  const pricing = state.pricing

  const totalPrice = pricing.yearlyPriceFull.formatted
  const discountedPrice = pricing.yearlyPriceDiscounted.formatted

  const yearlyPerMonthPrice = pricing.discountedMonthlyPrice.formatted

  const monthlyPrice = new Price(
    pricing.baseProduct.price,
    pricing.baseProduct.priceLocale,
  ).formatted

  const title = allStrings.emailPromo.yearlyTitle

  return (
    <div className={styles.container}>
      <button
        className={styles.yearlyContainer}
        onClick={() => {
          if (state.isDiscount) {
            native.subscribeWithDiscount(pricing.promoProduct)
          } else {
            native.subscribe(pricing.promoProduct)
          }
        }}
      >
        <div className={styles.bannerContainer}>
          <label className={styles.yearlyBannerTitle}>
            {strings.saleBanner}
          </label>
        </div>
        <div className={styles.yearlyInfo}>
          <label className={styles.yearlyTitle}>{title}</label>
          <div className={styles.subtitle}>
            <label>
              {strings.monthPrefix}
              <label
                style={{
                  textDecoration: "line-through",
                  textDecorationThickness: 2,
                }}
              >
                {totalPrice}
              </label>
              {" " + discountedPrice}
            </label>
            <label>{strings.perMonthPrice(yearlyPerMonthPrice)}</label>
          </div>
        </div>
      </button>
      <button
        className={styles.monthlyContainer}
        onClick={() => {
          native.subscribe(pricing.baseProduct)
        }}
      >
        <div className={`${styles.subtitle} ${styles.subtitleMonthly}`}>
          <label>{strings.monthly}</label>
          <label>{strings.perMonthPrice(monthlyPrice)}</label>
        </div>
      </button>
    </div>
  )
}

export default Payment
